import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, mergeProps as _mergeProps, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-35f4c6e7"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick", "onKeypress"]
const _hoisted_2 = {
  class: "visually-hidden visually-hidden_card",
  role: "button"
}
const _hoisted_3 = {
  class: "journey-item__main",
  "aria-hidden": "true"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "journey-item__route" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "journey-item__line" }),
  /*#__PURE__*/_createElementVNode("div", { class: "journey-item__point" }),
  /*#__PURE__*/_createElementVNode("div", { class: "journey-item__line" })
], -1))
const _hoisted_5 = { class: "journey-item__details" }
const _hoisted_6 = { class: "journey-item__text" }
const _hoisted_7 = { class: "journey-item__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_display_time = _resolveComponent("a-display-time")!
  const _component_a_icon = _resolveComponent("a-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: _ctx.redirectTo,
    custom: ""
  }, {
    default: _withCtx(({ navigate }) => [
      _createElementVNode("button", _mergeProps({ class: "journey-item" }, _ctx.componentProps, {
        onClick: navigate,
        onKeypress: _withKeys(navigate, ["enter"])
      }), [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.accessibleText), 1),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_a_display_time, {
            class: "journey-item__time",
            "aria-colindex": "1",
            "actual-time": _ctx.actualTime,
            "scheduled-time": _ctx.scheduledTime
          }, null, 8, ["actual-time", "scheduled-time"]),
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.title), 1)
            ]),
            (_ctx.allowNavigation)
              ? (_openBlock(), _createBlock(_component_a_icon, {
                  key: 0,
                  "icon-type": _ctx.ICON_TYPE.NAVIGATE_BLUE
                }, null, 8, ["icon-type"]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 16, _hoisted_1)
    ]),
    _: 1
  }, 8, ["to"]))
}